import React from "react";
import { styled } from "styled-components";
import { macOSCheck } from "../../../util/macOSCheck";

const PrimaryBtn = ({ style, onClick, disabled, btnText }) => {
  return (
    <StyledPrimaryBtn
      style={{
        ...style,
      }}
      isMac={macOSCheck()}
      onClick={onClick}
      disabled={disabled}
    >
      {btnText || "확인"}
    </StyledPrimaryBtn>
  );
};

export default PrimaryBtn;

const StyledPrimaryBtn = styled.button.attrs((props) => {})`
  font-family: "LINESeedKR-Rg";
  /* font-weight: normal; */
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;
  font-weight: 400;
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: -0.6px;
  color: #fff;

  width: 380px;
  height: 46px;
  text-align: center;
  border-radius: 12px;
  background-color: #5050ff;

  &:disabled {
    background-color: #dbdde0;
    color: #898e99;
  }

  &:hover {
    background-color: #8585ff;
    color: #fff !important;
  }

  &:focus {
    background-color: #000075;
  }
`;
